import { useState, useEffect, useRef } from 'react';
import { seiteBesuchenMarkieren } from '../api';

const _fromServer = new Set();
const _shownThisSession = new Set();
const _markedThisSession = new Set();

let _isReady = false;
let _callbacks = [];

export function initVisited(pages) {
  _fromServer.clear();
  _markedThisSession.clear();
  _shownThisSession.clear();
  (pages || []).forEach(p => _fromServer.add(p));
  _isReady = true;
  _callbacks.forEach(cb => cb());
  _callbacks = [];
}

export function resetVisited() {
  _fromServer.clear();
  _markedThisSession.clear();
  _shownThisSession.clear();
}

function onReady(cb) {
  if (_isReady) cb();
  else _callbacks.push(cb);
}

export default function useFirstVisit(page) {
  const [isFirst, setIsFirst] = useState(null);
  // ponytail: guards against StrictMode double-invoke (both closures share the same ref object)
  const firedRef = useRef(false);

  useEffect(() => {
    onReady(() => {
      if (firedRef.current) return;
      firedRef.current = true;
      const first = !_fromServer.has(page) && !_shownThisSession.has(page);
      setIsFirst(first);
      if (first) _shownThisSession.add(page);
      if (!_fromServer.has(page) && !_markedThisSession.has(page)) {
        _markedThisSession.add(page);
        seiteBesuchenMarkieren(page).catch(() => {});
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isFirst: isFirst === true, dismiss: () => setIsFirst(false) };
}
